import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const QuoteForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    orderType: '',
    description: ''
  });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    Object.keys(formData).forEach(key => data.append(key, formData[key]));
    if (file) data.append('rfqFile', file);

    try {
    // Replace axios calls with:
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';

// In your submit function:
await axios.post(`${API_URL}/quotes`, data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
      toast.success('Quote submitted successfully!');
      setFormData({ name: '', company: '', email: '', phone: '', orderType: '', description: '' });
      setFile(null);
    } catch (error) {
      toast.error('Failed to submit quote. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="quote" className="quote-section">
      <div className="container">
        <div className="quote-box">
          <div className="header">
            <span className="label">get started</span>
            <h3>Start Your RFQ</h3>
            <p>Choose a smarter way to source. Source globally. Stay compliant. Reduce emissions. All with one accountable partner.</p>
          </div>
          <form onSubmit={handleSubmit} className="quote-form">
            <div>
              <label>Name *</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
              />
            </div>
            <div>
              <label>Company *</label>
              <input
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                placeholder="Company name"
              />
            </div>
            <div>
              <label>Email *</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="email@domain.com"
              />
            </div>
            <div>
              <label>Phone</label>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+49 123 456789"
              />
            </div>
            <div className="full-width">
              <label>Order Type</label>
              <select
                name="orderType"
                value={formData.orderType}
                onChange={handleChange}
              >
                <option value="">— select —</option>
                <option value="prototype">Prototype / sample</option>
                <option value="small">Small series</option>
                <option value="mass">Mass production</option>
                <option value="consult">Consultation only</option>
              </select>
            </div>
            <div className="full-width">
              <label>Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                placeholder="Brief description of your requirements"
              />
            </div>
            <div className="full-width">
              <label>Upload RFQ</label>
              <div className="upload-area" onClick={() => document.getElementById('fileInput').click()}>
                <i className="fas fa-cloud-upload-alt"></i>
                <p>{file ? file.name : 'Drag & drop or click to upload (PDF, DWG, STEP)'}</p>
                <input id="fileInput" type="file" onChange={handleFileChange} accept=".pdf,.dwg,.step,.stp" />
              </div>
            </div>
            <div className="quote-submit">
              <button type="submit" className="btn-eu" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Quote Request'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default QuoteForm;